import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";

const Panel = ({ isSubmitting }) => {
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}></div>
      <div className={styles.btns}>
      <button
          type="submit"
          className={cn("button", styles.button)}
          disabled={isSubmitting}
        >
            Save & Continue
          </button>
      </div>
    </div>
  );
};
export default Panel;
